import { GQL_TIMESTAMP } from '@@partner:types:graphql'

export const mapToGQL_TIMESTAMP = (
  ts?: Date | number
): GQL_TIMESTAMP | undefined => {
  if (!ts) {
    return undefined
  }
  if (typeof ts === 'number') {
    return ts.toString() as GQL_TIMESTAMP
  }
  if (ts instanceof Date) {
    return ts.getTime().toString() as GQL_TIMESTAMP
  }
}
